import React, { useContext, useState, useEffect, useMemo } from 'react';
import {
  Widget,
  FormSelect,
  SimpleView,
  MasterDetailForm,
  GridView,
  Row,
  InlineEditTable,
  InlineEditColumnProps,
  Table,
  FormText,
  Button,
  FormInput,
  Form,
  Col,
  FormResetButton,
} from '@digital/ui';
import { SelectValue } from 'antd/lib/select';
import { hasPermission } from '@app/helpers/permissions';
import { Collapse, Icon, Input } from 'antd';
import { ContratadoRequisicaoCompraMaterial } from '@app/api/projeto';

interface FormResumoContratadoProps {
  contratadoRequisicaoCompraMaterial: ContratadoRequisicaoCompraMaterial[];
  style: any;
}

const { Panel } = Collapse;

const FormTableContratadoRequisicaoCompraMaterial = (props: FormResumoContratadoProps) => {
  const { contratadoRequisicaoCompraMaterial, style } = props;

  const [valorTotal, setValorTotal] = useState<string>();

  useEffect(() => {
    const getData = () => {
      if (contratadoRequisicaoCompraMaterial.length > 0) {
        var requisitado = contratadoRequisicaoCompraMaterial[contratadoRequisicaoCompraMaterial.length - 1];
        if (requisitado) {
          setValorTotal(requisitado.distribuidoTotalFormatado);
        } else {
          setValorTotal('');
        }
      }else{
        setValorTotal('');
      }
    };

    getData();
  }, [contratadoRequisicaoCompraMaterial]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'RC',
        dataIndex: 'contratadoCompraNumero',
        width: '2%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="contratadoCompraNumero"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.contratadoCompraNumero !== undefined &&
            record.contratadoCompraNumero
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
      {
        title: 'RC Seq',
        dataIndex: 'contratadoCompraSeq',
        width: '13%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="contratadoCompraNumero"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.contratadoCompraNumero !== undefined &&
            record.contratadoCompraNumero
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
      {
        title: 'Narrativa',
        dataIndex: 'narrativa',
        width: '35%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="contratadoCompraNumero"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.contratadoCompraNumero !== undefined &&
            record.contratadoCompraNumero
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
      {
        title: 'Valor total',
        dataIndex: 'requisicaoCompraValorTotalFormatado',
        width: '35%',
        align: 'center',
      },
      {
        title: 'No Projeto',
        dataIndex: 'valorDistribuidoFormatado',
        align: 'center',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'valorDistribuidoFormatado',
            width: '1%',
            align: 'center',
          },
        ],
      },
      {
        title: 'Valor à distribuir',
        dataIndex: 'valorParaDistribuidoFormatado',
        align: 'center',
        width: '35%',
      },
      {
        title: 'OC',
        dataIndex: 'contratadoCompraOc',
        align: 'center',
        width: '35%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="contratadoCompraOc"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.contratadoCompraOc !== undefined &&
            record.contratadoCompraOc
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
      {
        title: 'PCM',
        dataIndex: 'pedidoPcm',
        align: 'center',
        width: '35%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="pedidoPcm"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.pedidoPcm !== undefined &&
            record.pedidoPcm
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
    ] as InlineEditColumnProps<ContratadoRequisicaoCompraMaterial>[];
  };

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['2']}
        expandIcon={() => <Icon type="arrows-right_4" />}
        style={style}>
        <Panel key="2" header="ITENS DE REQUISIÇÃO DE COMPRA DE MATERIAL" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                <Button
                  title="Distribuir contratado material"
                  type="primary"
                  icon="commons-search"
                  onClick={() => {
                    window.location.href = `/contratopcm`;
                  }}
                />,
              ]}>
              <Row>
                <Table
                  rowKey="index"
                  id={"fbf0301f-3665-42d0-9a9a-5443284768c9"}
                  columns={customColumns()}
                  dataSource={contratadoRequisicaoCompraMaterial}
                  pagination={
                    {
                      pageSize: 5,
                      onChange: (() => {
                        document.getElementById("fbf0301f-3665-42d0-9a9a-5443284768c9").scrollIntoView();
                      })
                    }
                  }
                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableContratadoRequisicaoCompraMaterial;
